var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgApOffline(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.4267 10.5283L12.9284 13.0844M8.22053 21.9183H16.1343C19.3338 21.9183 21.9274 19.3246 21.9274 16.1252V12.1683V10.1898V8.41829C21.9274 5.10458 19.2411 2.41829 15.9274 2.41829H14.1559H12.1774H8.22053C5.02109 2.41829 2.42743 5.01195 2.42743 8.21139V16.1252C2.42743 19.3246 5.02109 21.9183 8.22053 21.9183ZM15.9274 11.8063C15.9274 13.8774 14.2485 15.5563 12.1774 15.5563C10.1064 15.5563 8.42744 13.8774 8.42744 11.8063C8.42744 9.73523 10.1064 8.0563 12.1774 8.0563C14.2485 8.0563 15.9274 9.73523 15.9274 11.8063Z",
    stroke: "#545454",
    strokeWidth: 1.33,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgApOffline);
export default __webpack_public_path__ + "static/media/AP_offline.25ab303478028008b3ee7133fe021f01.svg";
export { ForwardRef as ReactComponent };